<template>
  <Modal
    :title="title"
    :visible="visible"
    :wrap-class-name="wrapClassName"
    class-name="tt-modal--confirm"
    :mask-closable="maskClosable"
    :esc-closable="escClosable"
    :center="center"
    :ok-text="okText"
    :cancel-text="cancelText"
    :confirm-loading="confirmLoading"
    :ok-button="okButton"
    :cancel-button="cancelButton"
    :body-style="style"
    append-to-body
    @confirm="confirm"
    @cancel="cancel"
    @open="open"
    @close="close"
  >
    <div v-if="content" class="tt-modal--confirm-content" v-html="content" />
  </Modal>
</template>
<script>
import Vue from 'vue'
import Modal from './Modal'
import { hasOwnProperty } from 'utils/common'
export default {
  components: { Modal },
  data() {
    return {
      visible: false,
      content: '',
      title: '',
      wrapClassName: '',
      style: null,
      maskClosable: true,
      escClosable: false,
      okButton: true,
      cancelButton: true,
      okText: Vue.t('confirm'),
      cancelText: Vue.t('cancel'),
      center: true,
      confirmLoading: false
    }
  },
  methods: {
    update(props) {
      for (const name in props) {
        if (hasOwnProperty(this.$data, name)) {
          this[name] = props[name]
        }
      }
      if (props.onConfirm) {
        this.$on('confirm', props.onConfirm)
      }
      if (props.onCancel) {
        this.$on('cancel', props.onCancel)
      }
      if (props.onOpen) {
        this.$on('open', props.onOpen)
      }
      if (props.onClose) {
        this.$on('close', props.onClose)
      }
      if (props.duration) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.close()
        }, props.duration)
      }
    },
    confirm() {
      this.$emit('confirm')
      this.visible = false
    },
    cancel() {
      this.$emit('cancel')
      this.visible = false
    },
    open() {
      this.visible = true
      this.$emit('open')
    },
    close() {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>
<style lang="less">
.tt-modal--confirm {
  width: 400px;
  &-content {
    white-space: pre-wrap;
    max-height: 10.5em; // 限制高度
    padding: 0 20px;
    overflow-y: auto;
    overflow-x: hidden;
    color: var(--sub-text-color);
  }
  .tt-modal-title {
    color: var(--active-color);
  }
  .tt-modal-body {
    padding: 20px 0;
    text-align: center;
  }
  .tt-modal-footer {
    padding: 10px 20px 20px;
  }
}
</style>
